// extracted by mini-css-extract-plugin
module.exports = {"info-icon":"Info-module__info-icon__2_K4q"};